export const categories = [
  { slug: 'daily-contest', name: '每日大赛', icon: 'ri-fire-line', description: '每日最热吃瓜大赛实时追踪' },
  { slug: 'wanghong-dagua', name: '网红大瓜', icon: 'ri-user-star-line', description: '网红圈劲爆大瓜一网打尽' },
  { slug: 'shichui-baoguang', name: '实锤曝光', icon: 'ri-search-eye-line', description: '有据可查的真实爆料曝光' },
  { slug: 'dújia-ziyuan', name: '独家资源', icon: 'ri-vip-crown-line', description: '全网首发独家内部资源' },
  { slug: 'yule-bagua', name: '娱乐八卦', icon: 'ri-movie-line', description: '娱乐圈最新八卦资讯' },
];

export const hotList = [
  {
    id: 1,
    title: '某千万粉丝网红被曝税务问题，工作室连夜发声明回应',
    category: '网红大瓜',
    hotScore: '98.7万',
    time: '2小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Breaking%20news%20visual%20about%20internet%20celebrity%20scandal%20with%20dramatic%20lighting%2C%20mysterious%20silhouette%2C%20dark%20moody%20atmosphere%2C%20news%20report%20concept%2C%20warm%20accent%20highlights%2C%20editorial%20photography%20style&width=640&height=480&seq=hot-1-2026&orientation=landscape',
    slug: 'wanghong-shuiwu-wenti',
    excerpt: '据知情人透露，该网红近三年直播收入超两亿，却存在严重税务申报问题...',
  },
  {
    id: 2,
    title: '知名选秀节目选手私生活混乱，多位当事人同时发声',
    category: '娱乐八卦',
    hotScore: '87.3万',
    time: '4小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20concept%20with%20spotlight%20on%20stage%2C%20dark%20theater%20background%2C%20mysterious%20figure%20in%20shadows%2C%20cinematic%20noir%20style%2C%20warm%20tone%20highlights&width=640&height=480&seq=hot-2-2026&orientation=landscape',
    slug: 'xuanxiu-xuanshou-sishenghuo',
    excerpt: '节目刚结束不久，选手就被扒出大量私生活黑料，涉及多人关系...',
  },
  {
    id: 3,
    title: '某带货主播虚假宣传被实锤，消费者集体维权进行中',
    category: '实锤曝光',
    hotScore: '76.5万',
    time: '6小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Investigative%20news%20concept%20with%20documents%20and%20evidence%20files%2C%20dramatic%20lighting%2C%20mysterious%20corporate%20theme%2C%20dark%20background%20with%20warm%20highlights%2C%20editorial%20photo&width=640&height=480&seq=hot-3-2026&orientation=landscape',
    slug: 'daihuo-zhubo-xujia',
    excerpt: '直播间吹得天花乱坠的产品，实际效果与宣传严重不符，消费者怒了...',
  },
  {
    id: 4,
    title: '娱乐圈某顶流被拍到深夜约会，工作室未作回应',
    category: '每日大赛',
    hotScore: '65.2万',
    time: '8小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20concept%2C%20blurred%20city%20lights%20background%2C%20mysterious%20couple%20silhouette%2C%20cinematic%20moody%20atmosphere%2C%20warm%20street%20lighting%2C%20editorial%20style&width=640&height=480&seq=hot-4-2026&orientation=landscape',
    slug: 'dingliu-yuehui-paidao',
    excerpt: '狗仔蹲守三个月终于拍到实锤画面，画面清晰可见两人亲密互动...',
  },
  {
    id: 5,
    title: '某美食博主被扒抄袭他人创意，粉丝集体脱粉回踩',
    category: '网红大瓜',
    hotScore: '54.8万',
    time: '10小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20content%20creator%20controversy%20concept%2C%20split%20screen%20comparison%2C%20dramatic%20contrast%20lighting%2C%20social%20media%20drama%20theme%2C%20dark%20moody%20background%2C%20editorial%20photography&width=640&height=480&seq=hot-5-2026&orientation=landscape',
    slug: 'meishi-bozhu-chaoxi',
    excerpt: '多位原创博主联合发声，指控其长期系统性抄袭，证据链完整...',
  },
  {
    id: 6,
    title: '某综艺嘉宾现场互撕视频流出，节目组紧急公关',
    category: '独家资源',
    hotScore: '43.1万',
    time: '12小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20drama%20behind%20the%20scenes%20concept%2C%20heated%20confrontation%20atmosphere%2C%20studio%20lights%20with%20dramatic%20shadows%2C%20entertainment%20scandal%20theme%2C%20warm%20cinematic%20tones&width=640&height=480&seq=hot-6-2026&orientation=landscape',
    slug: 'zongyi-jiabin-husi',
    excerpt: '未播出版本遭内部人员泄露，现场火药味十足，嘉宾言辞激烈...',
  },
];

export const featuredArticles = [
  {
    id: 1,
    title: '深度起底：某MCN机构背后的灰色产业链',
    category: '实锤曝光',
    categorySlug: 'shichui-baoguang',
    time: '2025年7月5日',
    imageUrl: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20about%20corporate%20scandal%2C%20document%20files%20on%20desk%2C%20dramatic%20dark%20lighting%2C%20mysterious%20office%20atmosphere%2C%20noir%20cinematic%20style%2C%20warm%20accent%20highlights&width=900&height=600&seq=featured-1-2026&orientation=landscape',
    slug: 'mcn-huise-chanye',
    excerpt: '从签约到解约，我们独家获取了内部合同和财务流水，揭开MCN行业不为人知的一面...',
  },
  {
    id: 2,
    title: '独家专访：前艺人助理曝光圈内潜规则内幕',
    category: '独家资源',
    categorySlug: 'dújia-ziyuan',
    time: '2025年7月4日',
    imageUrl: 'https://readdy.ai/api/search-image?query=Exclusive%20interview%20concept%20with%20anonymous%20whistleblower%2C%20silhouette%20behind%20frosted%20glass%2C%20dark%20moody%20lighting%2C%20confidential%20theme%2C%20cinematic%20atmosphere%2C%20editorial%20photography&width=900&height=600&seq=featured-2-2026&orientation=landscape',
    slug: 'yiren-zhuli-baoguang',
    excerpt: '从业十年的艺人助理首次公开发声，讲述那些不为人知的娱乐圈生存法则...',
  },
  {
    id: 3,
    title: '数据说话：2025上半年网红翻车事件大盘点',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    time: '2025年7月3日',
    imageUrl: 'https://readdy.ai/api/search-image?query=Data%20analysis%20and%20statistics%20visualization%20concept%2C%20dramatic%20graphs%20and%20charts%2C%20dark%20modern%20tech%20atmosphere%2C%20news%20analytics%20theme%2C%20warm%20neon%20highlights%2C%20editorial%20style&width=900&height=600&seq=featured-3-2026&orientation=landscape',
    slug: '2025-shangbannian-fanche',
    excerpt: '从年初到现在，已有超过50位网红因各种原因翻车，我们整理了一份完整清单...',
  },
  {
    id: 4,
    title: '知情人士：某头部主播团队内部矛盾爆发始末',
    category: '网红大瓜',
    categorySlug: 'wanghong-dagua',
    time: '2025年7月2日',
    imageUrl: 'https://readdy.ai/api/search-image?query=Team%20conflict%20and%20internal%20drama%20concept%2C%20cracked%20glass%20visual%2C%20dark%20corporate%20atmosphere%2C%20dramatic%20lighting%20contrast%2C%20mysterious%20office%20scene%2C%20cinematic%20photography&width=900&height=600&seq=featured-4-2026&orientation=landscape',
    slug: 'toubu-zhubo-neibu-maodun',
    excerpt: '团队成员向本中心独家爆料，揭开头部主播光鲜背后的团队分裂真相...',
  },
];

export const dailyContest = [
  {
    id: 1,
    title: '今日最热：某女星与前经纪公司对簿公堂',
    votes: '12.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20legal%20dispute%20concept%2C%20courtroom%20drama%20atmosphere%2C%20dark%20formal%20setting%2C%20mysterious%20figure%20with%20documents%2C%20cinematic%20lighting%2C%20editorial%20style&width=800&height=500&seq=contest-1-2026&orientation=landscape',
    slug: 'nvxing-jingji-gongsi',
  },
  {
    id: 2,
    title: '热搜第一：某男团成员疑似恋情曝光',
    votes: '10.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Boy%20band%20romance%20rumor%20concept%2C%20spotlight%20on%20stage%20with%20mysterious%20shadow%2C%20dark%20concert%20atmosphere%2C%20dramatic%20lighting%2C%20entertainment%20news%20theme%2C%20editorial%20photo&width=800&height=500&seq=contest-2-2026&orientation=landscape',
    slug: 'nantuan-lianqing',
  },
  {
    id: 3,
    title: '实时追踪：某品牌代言人突然被替换',
    votes: '9.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Brand%20endorsement%20controversy%20concept%2C%20billboard%20being%20changed%2C%20dramatic%20urban%20night%20scene%2C%20mysterious%20corporate%20theme%2C%20warm%20city%20lights%2C%20editorial%20photography&width=800&height=500&seq=contest-3-2026&orientation=landscape',
    slug: 'daiyanren-tihuan',
  },
];

export const siteInfo = {
  name: '黑料吃瓜爆料中心',
  description: '专注每日大赛正能量内容与网红大瓜实锤曝光，全网独家资源首发，吃瓜热榜实时滚动更新，真实爆料有据可查，一站式满足吃瓜群众全部需求。',
  keywords: '黑料吃瓜,吃瓜爆料中心,每日大赛,网红大瓜,实锤曝光,吃瓜热榜,黑料不打烊,独家资源,真实爆料',
  slogan: '黑料不打烊，吃瓜每一天',
  email: 'contact@lymeijialaifu.cn',
};